import { observer } from 'mobx-react';
import * as React from 'react';
import * as style from './style.module.css';

interface Props {
  message: string;
}

const EXOInputErrorMessage: React.FC<Props> = ({ message }) => (
  <div className={style.root}>{message}</div>
);

export default observer(EXOInputErrorMessage);
